angular.module('tf.directives')

    .directive('templatesMenu', ['Template','ThumbnailSequence','$timeout','NotificationService','FileUploadService',
        function (Template, ThumbnailSequence, $timeout, NotificationService, FileUploadService) {
        return{
            restrict:'E',
            replace:true,
            scope:{
                project : "=",
                canProduce : "=",
                selected : "="
            },
            templateUrl:'js/components/templatesMenu/templatesMenu.html',
            link: function(scope,element,attr){
                // scope.horizontalScroll = false;
                scope.hideLeftArrow = true;
                scope.hideRightArrow = true;

                scope.selectAll = function(){
                    for(var i = 0 ; i < scope.project.templates.length ; i++){
                        scope.project.templates[i].use = true;
                    }
                    scope.canProduce = true;
                };

                scope.deselectAll = function(){
                    for(var i = 0 ; i < scope.project.templates.length ; i++){
                        scope.project.templates[i].use = false;
                    }
                    scope.canProduce = false;
                };

                scope.invertSelection = function(){
                    var counter = 0;
                    for(var i = 0 ; i < scope.project.templates.length ; i++){
                        scope.project.templates[i].use = !scope.project.templates[i].use;
                        if(scope.project.templates[i].use && !scope.project.templates[i].hide){
                            counter++;
                        }
                    }
                    scope.canProduce = counter > 0;
                };
                scope.toggleTemplateUse = function(template){
                    template.use = !template.use;
                    var counter =0;
                    for(var i = 0 ; i < scope.project.templates.length ; i++){
                        if(scope.project.templates[i].use  && !scope.project.templates[i].hide){
                            counter++;
                        }
                    }
                    scope.canProduce = counter > 0;
                };
                scope.selectTemplate = function(template){
                    if(!FileUploadService.isUploading){
                        scope.selected = template;
                        for(var i = 0 ; i < scope.project.templates.length ; i++){
                            scope.project.templates[i].isSelected = false;
                        }
                        template.isSelected = true;

                        scope.selected.thumbnail = template.thumbnail;
                        if(!scope.selected.thumbnailSequence){
                            scope.selected.thumbnailSequence = new ThumbnailSequence();
                        }
                    }else{
                        NotificationService.popup('confirm-exit', {
                            'onLeave': function(){
                                FileUploadService.isUploading = false;
                                scope.selectTemplate(template);
                            },
                            title: 'File is still uploading',
                            content:'Leaving the template will stop the file upload'

                        });
                    }
                };

                scope.duplicate = function(template){
                    var duplicate = new Template(template.duplicate());
                    scope.project.templates.splice(scope.project.templates.indexOf(template)+1,0,duplicate);

                    updateHorizontalScroll();
                };

                scope.delete = function(template) {
                    if (template.canDelete) {
                        var index = scope.project.templates.indexOf(template);
                        var wasSelected = template.isSelected;
                        scope.project.templates.splice(index, 1);
                        if(wasSelected) {
                            scope.selectTemplate(scope.project.templates[Math.max(0, index - 1)]);
                        }

                        if($('.templates-gallery')[0].scrollWidth >= element.innerWidth()) {
                            scope.hideRightArrow = false;
                        }else{
                            scope.hideRightArrow = true;
                            scope.hideLeftArrow = true;
                        }

                        updateHorizontalScroll();
                    }
                };

                function updateHorizontalScroll(){
                    $timeout(function() {
                        $('.scroll-arrow').removeClass('hide');
                        scope.hideLeftArrow = true;
                        scope.hideRightArrow = true;
                        var galleryElement = $('.templates-gallery')[0];
                        if(galleryElement) {
                            if (galleryElement.scrollWidth > element.innerWidth()) {
                                arrowsVisibility();
                            }
                        }
                    },1);
                }

                scope.deleteAll = function(){
                    var i = scope.project.templates.length;
                    while(i--){
                        if (scope.project.templates[i].canDelete){
                            scope.delete(scope.project.templates[i]);
                        }
                    }
                };

                scope.populateTemplates = function(file, template){
                    if(scope.project.isAllowedMimeType(file.type)) {
                        scope.project.populateTemplates(template, file).then(function(){
                            updateHorizontalScroll();
                        });
                    }
                };

                scope.hasTemplatesDuplicate = function(){
                    var result = false;
                    for(var i=0; i<scope.project.templates.length;i++){
                        if(scope.project.templates[i].settings && scope.project.templates[i].settings.duplicate){
                            result=true;
                            break;
                        }
                    }
                    return result;
                };

                scope.dragOverClass = function($event) {
                    var items = $event.dataTransfer.items;
                    var hasFile = false;
                    if (items !== null) {
                        for (var i = 0 ; i < items.length; i++) {
                            if (items[i].kind == 'file' && scope.project.isAllowedMimeType(items[i].type)) {
                                hasFile = true;
                                break;
                            }
                        }
                    } else {
                        hasFile = true;
                    }
                    return hasFile ? "dragover" : "dragover-err";
                };

                function resizeListener(){
                    scope.$apply(function(){
                        updateHorizontalScroll();
                    });
                }

                function arrowsVisibility(){
                    var totalThumbsWidth = $('.templates-gallery')[0].scrollWidth - $('.templates-gallery')[0].offsetWidth;

                    scope.$apply(function(){
                        scope.hideLeftArrow = $('.templates-gallery').scrollLeft() <= 0;
                    });
                    scope.$apply(function(){
                        if($('.templates-gallery').scrollLeft() === totalThumbsWidth) {
                            scope.hideRightArrow = true;
                        }else{
                            scope.hideRightArrow = false;
                        }

                    });
                }

                $timeout(function(){
                    scope.$apply(function() {
                        if($('.templates-gallery')[0].scrollWidth > window.innerWidth) {
                            scope.hideRightArrow = false;
                        }
                    });

                    new ResizeSensor($('#render-view-section'), resizeListener);

                    window.addEventListener("resize", resizeListener);
                    window.addEventListener("wheel", arrowsVisibility);

                },1);

                scope.scrollRight = function(){
                    var templateWidth = $('.template-thumbnail')[0].offsetWidth;
                    var numOftemplatesOnScreen = Math.floor($('.templates-gallery')[0].offsetWidth / templateWidth);
                    $('.templates-gallery').animate({scrollLeft: '+=' + (templateWidth * numOftemplatesOnScreen)}, 300, arrowsVisibility);

                };
                scope.scrollLeft = function(){
                    var templateWidth = $('.template-thumbnail')[0].offsetWidth;
                    var numOftemplatesOnScreen = Math.floor($('.templates-gallery')[0].offsetWidth / templateWidth);
                    $('.templates-gallery').animate({ scrollLeft: '-=' + (templateWidth * numOftemplatesOnScreen)}, 300, arrowsVisibility);
                };
                scope.$on('$stateChangeSuccess', function() {
                    window.removeEventListener("resize", resizeListener);
                    window.removeEventListener("wheel", arrowsVisibility);
                });
                updateHorizontalScroll();
            }
        };
    }]);